// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UzqF","image":"Header_image__3R4Wt","name":"Header_name__2K13L","info":"Header_info__J7Tc3","infoRow":"Header_infoRow__1siH4"};